/**
 * Small cross-wiring bridge, same pattern as `coinbase/accessTokenBridge.ts`: `api-client.ts` is
 * a plain module and needs the current Cloudflare Turnstile token to attach as
 * `X-Turnstile-Token`, but the widget itself only exists inside a React component
 * (`<TurnstileWidget>`, mounted on SignInPage). The widget writes its latest token here on every
 * solve/auto-refresh; the API client reads it when building a request.
 *
 * The backend only ever consults this header when it's about to provision a brand-new account
 * (see apps/api's services/identity.ts) — attaching it on every authenticated request is
 * harmless for a returning user, who the server never checks it for.
 */
let currentToken: string | null = null;

export function setTurnstileToken(token: string | null): void {
  currentToken = token;
}

export function getTurnstileToken(): string | null {
  return currentToken;
}
